import { format } from "date-fns";
import { de } from "date-fns/locale";
import { cn } from "@/lib/utils";
import { LEAD_STATUS, LEAD_TYPES } from "@/lib/leadLabels";

export const fmtDate = (iso) => (iso ? format(new Date(iso), "dd.MM.yyyy, HH:mm", { locale: de }) : "–");

const STATUS_CLS = {
  neu: "bg-brand-yellow text-brand-anthracite",
  in_bearbeitung: "bg-brand-sky-light text-brand-blue",
  erledigt: "bg-emerald-50 text-emerald-700",
};

const TYPE_CLS = {
  callback: "bg-white text-brand-anthracite ring-1 ring-slate-200",
  email: "bg-white text-brand-blue ring-1 ring-brand-blue/30",
  damage: "bg-brand-anthracite text-white",
};

export const StatusBadge = ({ status, testId }) => (
  <span className={cn("inline-flex rounded-full px-2.5 py-1 text-xs font-bold", STATUS_CLS[status])} data-testid={testId}>
    {LEAD_STATUS[status]}
  </span>
);

export const TypeBadge = ({ type }) => (
  <span className={cn("inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-bold", TYPE_CLS[type])}>{LEAD_TYPES[type]}</span>
);
